// extracted by mini-css-extract-plugin
module.exports = {"typeWrapper":"ingredients-type_typeWrapper__CQDyG","itemsWrapper":"ingredients-type_itemsWrapper__3XVLp"};